import React from 'react';
import {bool, func} from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Button, Grid} from 'semantic-ui-react';
import compose from 'recompose/compose';
import setDisplayName from 'recompose/setDisplayName';
import {unvalidatedBasicForm} from 'utils/helpers';
import {formDataManager} from 'hoc/formDataManager';

// allows for updating the form config dynamically.
// in this case, we want to disable checkboxes for any platforn on which the current campaign does
// not exist.
// as well, we want any checked checkboxes to remain checked after clicking the Update button.
const createPlatformFilter = (initialData, config) => {
  const PlatformFilterForm = unvalidatedBasicForm(config);

  const PlatformFilter = compose(
    setDisplayName('PlatformFilter'),
    formDataManager(initialData, config)
  )(props => (
    <div className='ugc-platform-filter'>
      <Grid>
        <Grid.Row>
          <Grid.Column verticalAlign='middle'>
            <PlatformFilterForm
              onValueChanged={props.onValueChanged}
              onValidationError={props.onValidationError}
              errors={props.errors}
              data={props.formData} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className={"ugc-platform-filter-update-button-row"}>
            <Button
                primary
                onClick={props.submit}
                loading={props.loading}>
                <FormattedMessage id='ugc.platform_filter.button' />
            </Button>
        </Grid.Row>
      </Grid>
    </div>
  ));

  PlatformFilter.propTypes = {
    loading: bool,
    onSaveData: func.isRequired
  };

  return PlatformFilter;
};

export default createPlatformFilter;



// WEBPACK FOOTER //
// ./public/pages/UGCModeration/PlatformFilter.jsx